// @ts-check
// @ts-ignore
/* eslint-disable @typescript-eslint/no-var-requires */
// const LocizeBackend = require('i18next-locize-backend/cjs');
// const ChainedBackend = require('i18next-chained-backend').default;
// const LocalStorageBackend = require('i18next-localstorage-backend').default;

const isBrowser = typeof window !== 'undefined';

// @ts-check
/* eslint-disable @typescript-eslint/no-var-requires */
const path = require('path');
/**
 * @type {import('next-i18next').UserConfig}
 */
module.exports = {
  // https://www.i18next.com/overview/configuration-options#logging
  debug: process.env.NEXT_PUBLIC_ENV === 'LOCAL',
  i18n: {
    defaultLocale: 'en',
    locales: ['en', 'cn', 'jp', 'br'],
    localeDetection: true,
  },
  // backend: {
  //   backendOptions: [
  //     {
  //       expirationTime: 60 * 60 * 1000, // 1 hour
  //     },
  //     {
  //       projectId: '76461916-92ee-4c7d-994f-80666851870a',
  //       version: 'latest',
  //       apiKey:'51b316ae-1fe4-4997-99aa-e3fe16a7ac1d'
  //     },
  //   ],
  //   backends: isBrowser ? [LocalStorageBackend, LocizeBackend] : [],
  // },
  /** To avoid issues when deploying to some PaaS (Vercel, etc.) */
  localePath:
    typeof window === 'undefined'
      ? path.resolve('./public/locales')
      : '/locales',

  reloadOnPrerender: process.env.NEXT_PUBLIC_ENV === 'LOCAL',
  partialBundledLanguages: isBrowser && true,
  /**
   * @link https://github.com/i18next/next-i18next#6-advanced-configuration
   */
  saveMissing: process.env.NEXT_PUBLIC_ENV === 'LOCAL' && isBrowser, // do not set saveMissing to true for production and also not when using the chained backend
  strictMode: true,
  serializeConfig: false,
  // react: { useSuspense: false }
  // use: isBrowser
  //   ? [
  //       ChainedBackend /*, require('locize').locizePlugin, require('locize-lastused')*/,
  //     ]
  //   : [],
};
